import React from 'react';
import { XR } from '..';
import clsx from 'clsx';
import { isFunction } from '../../util/isFunction';
export function SectionHeader(input) {
    var title = input.title, subtitle = input.subtitle, close = input.close, buttons = input.buttons;
    var isBackButtonLink = XR.util.isPathLike(close);
    var isBackButtonFunction = isFunction(close) && !isBackButtonLink;
    var backButtonElement = close && (React.createElement(XR.Button, { onClick: isBackButtonLink ? undefined : close, to: isBackButtonLink ? close : undefined, icon: isBackButtonLink ? 'arrow_back' : 'close', variant: 'text' }));
    var hasTopRow = Boolean(buttons && backButtonElement);
    return (React.createElement(XR.Section, { className: clsx('XR-SectionHeader') },
        hasTopRow && (React.createElement(XR.Box, { className: 'action-row' },
            React.createElement("div", null, backButtonElement),
            React.createElement("div", { className: 'buttons' }, buttons))),
        title && (React.createElement(XR.Box, { className: 'title' },
            React.createElement("div", null,
                React.createElement("div", { className: 'title-content' },
                    !hasTopRow && isBackButtonLink && backButtonElement,
                    React.createElement("label", null, title)),
                subtitle && React.createElement("div", { className: 'subtitle' }, subtitle)),
            buttons && !hasTopRow && React.createElement("div", { className: 'buttons' }, buttons),
            !buttons && isBackButtonFunction && React.createElement("div", null, backButtonElement)))));
}
